export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives19.f4ac3ebd.jpg";